<template>
  <div class="Mine" ref="Mine" v-show="mineData.length!=0">
    <!-- 导航栏 -->
    <van-nav-bar :border="false" ref="navBar">
      <template #title>
        <span class="title">我的</span>
      </template>
      <template #right>
        <router-link tag="span" :to="{name:'setUp'}" class="right">设置</router-link>
      </template>
    </van-nav-bar>
    <!-- 头部 -->
    <section class="mine-top" ref="mineT">
      <div class="mine-top-wrapper">
        <div class="header-pic">
          <div class="pic" v-if="pic">
            <img :src="pic" alt @click="switchPic" />
          </div>
          <van-uploader
            v-else
            :after-read="afterRead"
            :max-count="1"
            multiple
            :preview-full-image="false"
            :deletable="false"
          />
        </div>
        <div class="information">
          <p class="name">{{mineData.nick_name}}</p>
          <p class="id">
            ID:
            <span>{{mineData.mobile}}</span>
          </p>
        </div>
      </div>
    </section>
    <!-- 内容 -->
    <section class="lists-wrapper" ref="listsW">
      <ul class="lists" ref="lists">
        <!-- 浏览游戏 -->
        <div class="browsed-games">
          <p class="title">玩过的游戏:</p>
          <div class="games">
            <div class="li" v-for="(item,index) in mineData.played_game" :key="index">
              <div class="g-icon">
                <img
                  :src="item.icon_url"
                  alt
                  v-if="index<4"
                  @click="gameDateil('gamedetails',{gameid: item.gid})"
                />
                <img src="@assets/image/mine/i-gengduo.png" alt v-else @click="morePlayGames" />
              </div>
              <p class="g-name" v-if="index<4">{{item.game_name}}</p>
              <p class="g-name" v-else>更多</p>
            </div>
          </div>
        </div>
        <!-- 工具列表1 -->
        <div class="tool-1">
          <ul>
            <router-link tag="li" :to="{name:'tool1',query:{id:1}}">
              <i class="i-yue"></i>
              <div class="li-r">
                <span>游戏余额</span>
                <span class="money"></span>
              </div>
            </router-link>
            <router-link tag="li" :to="{name:'tool1',query:{id:2}}">
              <i class="i-gift"></i>
              <div class="li-r">
                <span>已领取礼包</span>
              </div>
            </router-link>
            <router-link tag="li" :to="{name:'tool1',query:{id:3}}">
              <i class="i-record"></i>
              <div class="li-r">
                <span>充值记录</span>
              </div>
            </router-link>
          </ul>
        </div>
        <!-- 工具列表2 -->
        <div class="tool-2">
          <ul>
            <li @click="onRealName">
              <i class="i-real"></i>
              <div class="li-r">
                <span>实名认证</span>
                <span class="noReal">{{realName?'已实名':'未实名'}}</span>
              </div>
            </li>
            <router-link tag="li" :to="{name:'tool2',query:{type:2}}" v-if="false">
              <i class="i-bind"></i>
              <div class="li-r">
                <span>手机绑定</span>
                <span class="noBind">未绑定</span>
              </div>
            </router-link>
            <router-link tag="li" :to="{name:'tool2',query:{type:3}}" v-if="false">
              <i class="i-password2"></i>
              <div class="li-r">
                <span>忘记密码</span>
              </div>
            </router-link>
            <router-link tag="li" :to="{name:'tool2',query:{type:4}}">
              <i class="i-password"></i>
              <div class="li-r">
                <span>修改密码</span>
              </div>
            </router-link>
          </ul>
        </div>
        <!-- 工具列表2 -->
        <div class="tool-3">
          <ul>
            <router-link tag="li" :to="{name:'news'}">
              <i class="i-news"></i>
              <div class="li-r">
                <span>消息</span>
              </div>
            </router-link>
            <router-link tag="li" :to="{name:'service'}">
              <i class="i-service"></i>
              <div class="li-r">
                <span>客服</span>
              </div>
            </router-link>
          </ul>
        </div>
      </ul>
    </section>
  </div>
</template>

<script>
import { contTools, lyTool } from "@/mixins/contMixins";
import wapApiFun from "@/servers/wap-module/apiFun";
import comTools from "@/assets/js/until";
export default {
  name: "Mine",
  mixins: [contTools],
  components: {},
  data() {
    return {
      mineData: "",
      fileList: [],
      realName: this.$cookies.get("realName") || "",
      disable: true, // 禁用切换头像
      pic: "https://img.yzcdn.cn/vant/leaf.jpg"
    };
  },
  computed: {},
  created() {
    this.initData();
  },
  mounted() {
    // let bodyH = document.body.clientHeight;
    // let navBarH = this.$refs.navBar.$el.clientHeight;
    // let mineTH = this.$refs.mineT.offsetHeight;
    let listsH = this.$refs.lists.offsetHeight;
    let tabBarH = document.querySelector("#tab-bar").offsetHeight;
    this.$refs.listsW.style.height = listsH + tabBarH * 2 + "px";
    // console.log(tabBarH);
  },
  methods: {
    // 数据初始化
    initData() {
      let data = comTools.assignObj(this.wapConfig(), {
        mobile: this.$cookies.get("mobile"),
        user_token: this.$cookies.get("userToken")
      });
      data.sign = comTools.querySort(data);
      wapApiFun.mine(data).then(res => {
        if (res.code == 200) {
          this.mineData = res.data;
          this.pic = this.mineData.head_url
          console.log("mine", this.mineData);
          if (!this.realName) {
            this.realName = this.mineData.real_name;
            console.log("realName", this.realName);
            this.$cookies.set("realName", this.mineData.real_name);
            this.$cookies.set("idNumber", this.mineData.id_number);
          }
          // 是否推送消息
          this.$cookies.set("is_news_push", this.mineData.is_news_push);
          // this.$toast(res.msg);
        } else {
          this.$toast(res.msg);
        }
      });
    },
    // 更换图片触发
    switchPic() {
      if (this.disable) return;
      console.log("更换图片", this.pic);
      this.$dialog
        .confirm({
          title: "更改头像"
        })
        .then(() => {
          this.pic = "";
        });
    },
    // 更换图片处理
    async afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      console.log(file);
      let _pic = await file.content;
      if (_pic) {
        setTimeout(() => {
          this.pic = _pic;
          file.status = "success";
          file.message = "上传成功";
        }, 1000);
      } else {
        setTimeout(() => {
          file.status = "failed";
          file.message = "上传失败";
        }, 1000);
      }
    },
    // 更多玩过的游戏
    morePlayGames() {
      this.$router.push({
        name: "moreGame"
      });
    },
    // 实名
    onRealName() {
      if (this.realName) {
        this.$toast("已实名");
      } else {
        this.$router.push({ name: "tool2", query: { type: 1 } });
      }
    }
  }
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/com.less";
.Mine {
  width: 100%;
  .view-bg-color();
  // background-color: #f00;
  // 导航栏
  .van-nav-bar {
    .theme-bg-color();
    color: #fff;
    .title,
    .right {
      font-weight: bold;
      color: #fff;
    }
  }
  // 头部
  .mine-top {
    width: 100%;
    padding-bottom: 1.5rem;
    // .theme-bd-color();
    .theme-bg-color();
    .mine-top-wrapper {
      width: 90%;
      display: flex;
      margin: 0 auto;
      .header-pic {
        width: 80px;
        // display: inline-block;
        .pic {
          width: 80px;
          height: 80px;
          background-color: #fff;
          .borderRadius(0.3rem);
          img {
            .borderRadius(6px);
            .img(100%);
          }
        }
      }
      .information {
        .flex-column(space-around);
        margin-left: 0.2rem;
        color: #fff;
        .id {
          font-size: 0.4rem;
          span {
            // padding-left: 3px;
          }
        }
      }
    }
  }
  // 内容
  .lists-wrapper {
    position: relative;
    width: 100%;
    .lists {
      position: absolute;
      left: 50%;
      top: -1rem;
      transform: translate(-50%, 0);
      width: 90%;
      margin: 0 auto;
      overflow: hidden;
      .borderRadius(0.3rem);
      > div {
        background-color: #fff;
        width: 100%;
        .borderRadius(0.3rem);
        .boxShadow(1px);
        // border: 1px solid #fff;
        margin-bottom: 0.5rem;
        // &:last-child {
        //   margin-bottom: 100px;
        // }
      }
      // 浏览游戏
      .browsed-games {
        padding: 0 0.3rem;
        font-size: 0.4rem;
        box-sizing: border-box;
        > .title {
          padding-top: 0.2rem;
          padding-bottom: 0.1rem;
          .theme-color();
        }
        .games {
          .jc-around();
          .li {
            width: 18%;
            .g-icon {
              img {
                .img();
              }
            }
            .g-name {
              padding: 0.1rem 0;
              text-align: center;
              .ellipsis();
              font-size: 0.3rem;
            }
          }
        }
      }
      // 工具列表1
      .tool-1,
      .tool-2,
      .tool-3 {
        ul {
          li {
            .jc-content(auto);
            padding: 0.3rem;
            font-size: 0.45rem;
            i {
              display: inline-block;
              width: 0.8rem;
              height: 0.8rem;
              margin-right: 0.2rem;
              &.i-yue {
                background: url("~@assets/image/mine/i-qianbao.png") no-repeat;
                background-size: contain;
              }
              &.i-gift {
                background: url("~@assets/image/mine/i-libao.png") no-repeat;
                background-size: contain;
              }
              &.i-record {
                background: url("~@assets/image/mine/i-chongzhi.png") no-repeat;
                background-size: contain;
              }
              &.i-real {
                background: url("~@assets/image/mine/i-shiming.png") no-repeat;
                background-size: contain;
              }
              &.i-bind {
                background: url("~@assets/image/mine/i-shouji.png") no-repeat;
                background-size: contain;
              }
              &.i-password {
                background: url("~@assets/image/mine/i-mima.png") no-repeat;
                background-size: contain;
              }
              &.i-password2 {
                background: url("~@assets/image/mine/i-wangjimima.png")
                  no-repeat;
                background-size: contain;
              }
              &.i-news {
                background: url("~@assets/image/mine/i-xiaoxi.png") no-repeat;
                background-size: contain;
              }
              &.i-service {
                background: url("~@assets/image/mine/i-kefu.png") no-repeat;
                background-size: contain;
              }
            }
            .li-r {
              width: calc(~"100% - 1.2rem");
              .jc-between();
              span {
                &:nth-of-type(2) {
                  .font-color();
                  font-size: 0.35rem;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>